import React from 'react';
import PropTypes from 'prop-types';

import { HAS_WINDOW } from 'eventbrite_design_system/utils/dom';
import Pagination from 'eventbrite_design_system/pagination/Pagination';
import Divider from 'eventbrite_design_system/divider/Divider';
import TrendingSearchesAnchor from './TrendingSearchesAnchor';

export default class SearchFooter extends React.Component {
    static propTypes = {
        currentPage: PropTypes.number.isRequired,
        totalNumResults: PropTypes.number.isRequired,
        hasEventResults: PropTypes.bool,
    };

    _onGetPage = (pageNumber) => {
        const { handleGetPage, history } = this.props;

        if (HAS_WINDOW) {
            window.scrollTo(0, 0);
        }
        // Offset by -1 because our Redux pagination assumes pages start at 0, EDS assumes pages start at 1
        handleGetPage(pageNumber - 1, history);
    };

    render() {
        const {
            currentPage,
            totalNumResults,
            trendingSearchData,
            hasEventResults,
        } = this.props;

        return (
            <footer className="eds-l-mar-bot-10">
                {hasEventResults && (
                    <Pagination
                        // If currentPage is 0 we want to default to 1 instead
                        pageNumber={currentPage + 1}
                        totalNumResults={totalNumResults}
                        size="minimal"
                        // eslint-disable-next-line react/jsx-handler-names
                        onSelected={this._onGetPage}
                    />
                )}
                <div className="eds-l-pad-top-6 eds-l-pad-bot-8">
                    <Divider color="ui-200" />
                </div>
                <TrendingSearchesAnchor
                    trendingSearchData={trendingSearchData}
                />
            </footer>
        );
    }
}
